/*
 * Badges
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import * as R from 'ramda';
import { BadgeRole, BadgeType, BadgeBTC } from './components';

export type BadgesProps = {
  device?: $PropertyType<DeviceQuery, 'device'>,
  hasDeposit?: Boolean,
  role?: String,
  size?: Number,
  type?: String,
};

const BadgesWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;

  & > div {
    margin-right: -13px;
  }
`;

/**
 * Badges React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {boolean} [props.hasDeposit] - has deposit flag
 * @param {string} [props.role] - user role value
 * @param {number} [props.size] - badges size
 * @param {string} [props.type] - user type value
 * @param {Object} [props.intl] - locale
 * @example <caption>Simple usage</caption>
 * <Badges hasDeposit=false rank="D" role="C" type="GC" />
 * @returns {React.Node<*>} React-component
 */
export const Badges = ({
  hasDeposit,
  role,
  size,
  type,
  intl = { locale: 'en' },
}: BadgesProps) => (
  <BadgesWrapper>
    {hasDeposit && <BadgeBTC size={size} locale={intl.locale} />}
    {type && !R.isEmpty(type) && role !== 'M' && (
      <BadgeType role={role} type={type} size={size} />
    )}
    {role && !R.isEmpty(role) && role === 'M' && (
      <BadgeRole role={role} size={size} />
    )}
  </BadgesWrapper>
);
